import Drawer from "../../components/drawer";
import Notification from "../../components/svg/notification";
import Label from "../../components/label";
import Close from "../../components/svg/close";
import SingleDot from "../../components/svg/single-dot";
import UserImage from "../../assets/images/user.png";

export default function NofificationDrawer(props = {}) {
  const { isOpen, setIsOpen } = props;

  const handleClose = () => {
    setIsOpen(false);
  };

  const notifications = [
    { id: 1, title: "A new Work Request has been submitted for your review." },
    { id: 2, title: "A new Work Request has been submitted for your review." },
    { id: 3, title: "A new Work Request has been submitted for your review." },
    { id: 4, title: "A new Work Request has been submitted for your review." },
    { id: 5, title: "A new Work Request has been submitted for your review." },
    { id: 6, title: "A new Work Request has been submitted for your review." },
    { id: 7, title: "A new Work Request has been submitted for your review." },
    { id: 8, title: "A new Work Request has been submitted for your review." },
    { id: 9, title: "A new Work Request has been submitted for your review." },
    { id: 10, title: "A new Work Request has been submitted for your review." },
    { id: 11, title: "A new Work Request has been submitted for your review." },
    { id: 12, title: "A new Work Request has been submitted for your review." },
    { id: 13, title: "A new Work Request has been submitted for your review." },
    { id: 14, title: "A new Work Request has been submitted for your review." },
    { id: 15, title: "A new Work Request has been submitted for your review." },
    { id: 16, title: "A new Work Request has been submitted for your review." },
  ];

  return (
    <Drawer value={isOpen} setIsOpen={setIsOpen} onOverlayClick={handleClose}>
      <div classNames={{ content: "bg-white w-[40vw]" }}>
        <div className="flex justify-between items-center p-4 border-b-[1px]">
          <div className="flex items-center space-x-3">
            <Notification className="text-[#2C2C2C]" />
            <Label className="mb-0 text-[20px] font-[500] text-[#2C2C2C]" label="Notifications" />
          </div>
          <div role="button" tabIndex={0} className="cursor-pointer" onClick={handleClose}>
            <Close />
          </div>
        </div>
        <div className="p-3 h-[90vh] overflow-y-auto">
          {notifications.map((item, index) => (
            <div key={index} className="p-2 py-4 flex">
              <img src={UserImage} className="h-[54px] w-[54px]" alt="user" />
              <div className="flex flex-col ml-4 mt-2">
                <Label className="mb-0 text-[#2C2C2C]" label={item.title} />
                <div className="flex items-center space-x-2 mt-2">
                  <Label className="mb-0 text-[#686868] text-[10px]" label="1 min ago" />
                  <SingleDot />
                  <Label className="mb-0 text-[#393188] text-[10px]" label="Project 1" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Drawer>
  );
}
